(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('dialog');
      this.addUrl = this.dataset.addUrl;
      this.changeUrl = this.dataset.changeUrl;
      this.cartUrl = this.dataset.cartUrl;

      document.querySelectorAll('[data-cart-open]').forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        });
      });

      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
          event.preventDefault();
          this.addFromForm(form);
        }
      });

      if (this.dialog) {
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
      }

      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-cart-close], [data-qty-increase], [data-qty-decrease], [data-cart-remove]');
        if (!trigger) return;
        if (trigger.hasAttribute('data-cart-close')) {
          this.close();
          return;
        }
        const line = trigger.getAttribute('data-line');
        const input = this.querySelector('[data-qty-input][data-line="' + line + '"]');
        let quantity = input ? parseInt(input.value, 10) || 0 : 0;
        if (trigger.hasAttribute('data-cart-remove')) quantity = 0;
        else if (trigger.hasAttribute('data-qty-increase')) quantity += 1;
        else if (trigger.hasAttribute('data-qty-decrease')) quantity = Math.max(0, quantity - 1);
        this.changeLine(line, quantity);
      });

      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-qty-input]');
        if (input) this.changeLine(input.getAttribute('data-line'), Math.max(0, parseInt(input.value, 10) || 0));
      });
    }

    open() {
      if (this.dialog && typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else if (this.dialog) this.dialog.setAttribute('open', '');
      document.querySelectorAll('[data-cart-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    }

    close() {
      if (this.dialog) this.dialog.close();
      document.querySelectorAll('[data-cart-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    }

    /* One wait, always the thread. The `kind` argument is kept so the existing
       call sites read the same, but there is nothing else to choose. The element
       is inside [data-cart-contents], so a render() wipes it — settle() only has
       to clear the panel attribute. */
    wait() {
      const panel = this.querySelector('[data-cart-contents]');
      if (!panel) return;
      panel.setAttribute('data-waiting', 'thread');
      const el = panel.querySelector('[data-cart-thread]');
      if (el) el.hidden = false;
    }

    settle() {
      const panel = this.querySelector('[data-cart-contents]');
      if (!panel) return;
      panel.removeAttribute('data-waiting');
      panel.querySelectorAll('[data-cart-thread]').forEach((el) => {
        el.hidden = true;
      });
    }

    async addFromForm(form) {
      const button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-busy', 'true');

      /* The drawer waits for the garment (owner, 2026-09-03). It used to open
         on the tap, which meant the common case was a drawer that arrived
         holding a loading thread and filled in a beat later — read as "it
         opened before it was ready" rather than as speed.

         This supersedes the earlier decision to open immediately. That decision
         was right about the risk — a silent button gets tapped twice — but its
         premise no longer holds: the button now carries `aria-busy`, and
         `.buybox__add-spinner` rides it, so the tap is acknowledged where it
         happened.

         There is deliberately no timeout that opens the drawer early. Two were
         tried and both were worse than waiting. `/cart/add.js` from this
         machine runs 430 / 457 / 458 / 517 / 533 / 748 ms over six calls,
         median 517, so a 400ms valve fired on every one of them and produced
         the exact bug it was hedging against. Raising it to 1200 still caught
         a 1265ms call — and what the shopper saw was not a loading state but
         "Your cart is empty", because the thread lives inside the panel the
         render is about to replace.

         The wait is carried where the tap happened instead: `aria-busy` on the
         button drives `.buybox__add-spinner`, verified visible mid-flight. A
         spinning button during a slow request is honest; a drawer that opens
         and says the cart is empty is not. */
      let opened = false;
      const reveal = () => {
        if (opened) return;
        opened = true;
        this.open();
      };

      const body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);
      try {
        const response = await fetch(this.addUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body,
        });
        const data = await response.json();
        /* Render before revealing, so the drawer is never seen without the
           thing that was just added to it. */
        if (response.ok && !data.status) {
          this.render(data.sections);
        }
      } catch (error) {
        /* fall back silently; the form still works without JS */
      }
      reveal();
      this.settle();
      if (button) button.removeAttribute('aria-busy');
    }

    /* Every cart surface rendered on this page, by its real section id.
       The cart page's id is read from the DOM, never hard-coded: templates/cart.json
       calls the section "main", but its rendered id is namespaced per theme
       instance (template--21500949364930__main) and asking for "main" returns
       null — the failure is silent, which is what made the two surfaces drift. */
    cartSections() {
      const ids = ['cart-drawer'];
      const page = document.querySelector('[data-cart-page]');
      const wrapper = page && page.closest('[id^="shopify-section-"]');
      if (wrapper) ids.push(wrapper.id.replace('shopify-section-', ''));
      return ids;
    }

    async changeLine(line, quantity) {
      /* Show the new digit now, not in ~660ms when the section comes back. The
         round trip has to re-render the whole section server-side, and waiting
         on it made the drawer feel markedly slower than the cart page, which
         updates locally before it posts.

         It also fixes a correctness bug: the click handler reads the current
         input value, so three fast taps used to send 2, 2, 2 instead of 2, 3, 4.
         Quantity 0 is left alone — the row is about to disappear, and blinking
         it to "0" first is worse than nothing. */
      if (quantity > 0) {
        document.querySelectorAll('[data-qty-input][data-line="' + line + '"]').forEach((input) => {
          input.value = quantity;
        });
      }

      /* Serialised, one request at a time. Fired concurrently, /cart/change.js
         calls race and the cart settles on whichever the server happened to
         finish last — three fast taps showed 4 while the cart really held 2.
         Chaining makes the final request the final state, so the digit above is
         a promise the cart keeps. */
      const seq = (this.pending = (this.pending || 0) + 1);

      this.queue = (this.queue || Promise.resolve()).then(async () => {
        /* The rows are on screen and the digit has already moved. The hairline
           says the cart is still writing it down. */
        this.wait();
        try {
          const response = await fetch(this.changeUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              line: Number(line),
              quantity: quantity,
              sections: this.cartSections().join(','),
              sections_url: window.location.pathname,
            }),
          });
          if (!response.ok) {
            if (seq === this.pending) await this.resync();
            return false;
          }
          const data = await response.json();
          /* Only the newest may paint — an intermediate render would snap the
             digit back to 2 on its way to 4. */
          if (seq === this.pending) this.render(data.sections);
          return true;
        } catch (error) {
          if (seq === this.pending) await this.resync();
          return false;
        } finally {
          /* Same guard as the paint: the thread belongs to the whole run of taps,
             not to each one, so only the last request puts it away. */
          if (seq === this.pending) this.settle();
        }
      });

      return this.queue;
    }

    /* The optimistic digit above is only honest while the request succeeds.
       `/cart/change.js` answers 422 when a line cannot go to the asked-for
       quantity — the common case is the last one in stock — and until
       2026-09-07 nothing repainted afterwards, so the drawer went on showing 2
       over a cart holding 1, with no error anywhere. This asks the server for
       the cart surfaces as they actually are and paints those.

       The Section Rendering API on a plain GET, not another change: nothing is
       being written, and a failed write is exactly the moment not to guess. If
       this fetch fails too the digit is left alone — the next navigation
       corrects it, and two wrong guesses are worse than one.

       Addressed at `/cart`, not at the page the shopper is standing on. The
       drawer is rendered from `layout/theme.liquid` rather than from a template,
       so `?sections=cart-drawer` is only resolvable on the cart's own URL —
       measured: 200 from `/cart`, 404 from `/collections/all`. (`/cart/change.js`
       is more permissive, which is why the happy path never noticed.) The cart
       page's own section is on that URL too, so one request covers both. */
    async resync() {
      try {
        const url = new URL(this.cartUrl || '/cart', window.location.origin);
        url.searchParams.set('sections', this.cartSections().join(','));
        /* No `Accept: application/json`. With that header `/cart` answers with
           the cart object — token, items, totals — and the sections are simply
           not in it; without it the same URL returns the rendered sections this
           needs. The failure is silent either way, because both are valid JSON. */
        const response = await fetch(url);
        if (!response.ok) return;
        this.render(await response.json());
      } catch (error) {
        /* leave it; a reload will correct it */
      }
    }

    render(sections) {
      if (!sections) return;

      const drawer = sections['cart-drawer'];
      if (drawer) {
        const doc = new DOMParser().parseFromString(drawer, 'text/html');
        const next = doc.querySelector('[data-cart-contents]');
        const current = this.querySelector('[data-cart-contents]');
        if (next && current) {
          current.innerHTML = next.innerHTML;
          /* The help panels live inside the swapped markup, so this replaced
             live `<details>` elements with fresh ones. Their CSS opens on
             `.is-open`, which only the accordion script adds — unbound rows take
             the click and reveal a panel that never grows. Idempotent, so the
             rows that survived are skipped. The cart page's copy is re-bound in
             the branch below; the drawer needs its own because the two are
             different elements replaced by different code paths. */
          if (typeof window.etreeAccordions === 'function') window.etreeAccordions(current);
        }
        const count = doc.querySelector('[data-cart-total-count]');
        if (count) {
          const value = count.getAttribute('data-cart-total-count');
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = value;
            /* Toggle the class, never `hidden` — display: none would skip the
               fade-up the header badge animates with. */
            el.classList.toggle('header__cart-count--on', value !== '0');
          });
        }
      }

      /* The cart page, when we are standing on it. Swapping .cart-page__inner
         replaces the <cart-page> element inside it, which re-upgrades and
         rebinds its own listeners — so the swap belongs here, not in there. */
      const page = document.querySelector('[data-cart-page]');
      const wrapper = page && page.closest('[id^="shopify-section-"]');
      const html = wrapper && sections[wrapper.id.replace('shopify-section-', '')];
      if (page && html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-cart-page]');
        if (next) page.innerHTML = next.innerHTML;
        /* The help panels are inside the swap, so this replaced live <details>
           elements with fresh ones. Their CSS opens on `.is-open`, which only the
           accordion script adds — unbound rows would take the click and reveal a
           panel that never grows. Idempotent, so the surviving rows are skipped. */
        if (typeof window.etreeAccordions === 'function') window.etreeAccordions(page);
        /* The phone's pay bar is inside the swap too, and its observer holds a
           reference to the element it was given. The cart page listens for this
           and re-applies its state to whatever is on the page now. */
        document.dispatchEvent(new CustomEvent('etree:cart-page-rendered'));
      }
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* Quantity changes are handed to <cart-drawer>, which owns the serialised
     request queue and repaints every cart surface on the page. Posting the form
     instead reloaded the whole document — ~1460ms for one tap — and left the
     drawer and this page free to disagree. Remove stays a plain link. */
  class CartPage extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      /* Quantity moves through − and + only. Set here rather than in the markup
         so it appears exactly when the buttons work: with no JS the buttons are
         inert, and typing plus the <noscript> Update button is the only way to
         change a quantity. */
      this.querySelectorAll('[data-qty-input]').forEach((input) => {
        input.readOnly = true;
      });

      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-qty-increase], [data-qty-decrease]');
        if (!trigger) return;
        const line = trigger.getAttribute('data-line');
        const input = this.querySelector('[data-qty-input][data-line="' + line + '"]');
        if (!input) return;
        const current = parseInt(input.value, 10) || 0;
        this.commit(line, trigger.hasAttribute('data-qty-increase') ? current + 1 : Math.max(0, current - 1));
      });
    }

    async commit(line, quantity) {
      const controller = document.querySelector('cart-drawer');
      if (controller && typeof controller.changeLine === 'function') {
        if (await controller.changeLine(line, quantity)) return;
      }
      /* No controller, or the request failed: fall back to the full-page post.
         Slower, but a flaky network degrades to a reload rather than to a page
         showing a quantity the cart does not have. */
      const form = this.querySelector('[data-cart-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    }
  }

  if (!customElements.get('cart-page')) customElements.define('cart-page', CartPage);

  /* The phone's pay block floats until its own place in the page arrives.

     One predicate, read on scroll: the block floats while the top of its slot is
     still below where the floating block's own top edge sits. When the two meet
     the attribute comes off and the block lands exactly where it was already
     drawn, so the exchange is a cut rather than a move — the same trick the
     product page's Add to bag makes, minus the second state.

     A scroll listener and not an IntersectionObserver, which is what this was
     first. The observer works on a real scroll and fails on a jump: with the
     root shortened by the block's height, "slot below the fold" and "slot
     scrolled past" are both *not intersecting*, so a scrollTo straight from one
     to the other is not a change and fires nothing — the total came back for a
     second appearance over the footer. Reading the position outright has no such
     state to go stale. Passive, and coalesced to one measurement a frame.

     The height is measured and re-measured on resize, because the block is two
     text rows and a button whose height is a token; hard-coding it here would be
     a fourth place to keep 48px in step.

     Below 900px only; above it the block is in the flow and there is nothing to
     carry. Re-run after a cart change, because the slot is inside the swapped
     markup and this holds the element it was given. */
  (function () {
    var narrow = window.matchMedia('(max-width: 899.98px)');
    var slot = null;
    var bar = null;
    var height = 0;
    var queued = false;

    var apply = function () {
      queued = false;
      if (!slot || !bar) return;
      if (!narrow.matches) {
        bar.removeAttribute('data-floating');
        return;
      }
      bar.toggleAttribute('data-floating', slot.getBoundingClientRect().top > window.innerHeight - height);
    };

    var schedule = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(apply);
    };

    var mount = function () {
      slot = document.querySelector('[data-pay-slot]');
      bar = slot && slot.querySelector('[data-cart-pay]');
      if (!slot || !bar) return;

      if (!narrow.matches) {
        slot.style.minHeight = '';
        bar.removeAttribute('data-floating');
        return;
      }

      /* Measured in the flow. The slot holds the height while the block is out
         of it, so the landing moves nothing. */
      bar.removeAttribute('data-floating');
      slot.style.minHeight = '';
      height = Math.round(bar.getBoundingClientRect().height);
      slot.style.minHeight = height + 'px';

      /* The slot's left edge is the content column's left edge. The floating
         block is full-bleed, so it needs that as padding to keep its contents
         on the same line they land on. */
      bar.style.setProperty('--pay-inset', Math.round(slot.getBoundingClientRect().left) + 'px');
      apply();
    };

    mount();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', mount);
    narrow.addEventListener('change', mount);
    document.addEventListener('etree:cart-page-rendered', mount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    /* The live count on SHOW N ITEMS. Nobody should apply a filter that empties
       the page, and the number cannot be worked out on the client: the value
       counts say how many products carry each value, not how two groups
       intersect. So the prospective URL is rendered server-side through the
       Section Rendering API and the button and the per-value counts are copied
       out of it. Nothing is applied until the button is pressed, so the address
       bar still only changes on submit. */
    var filterForm = document.querySelector('[data-filter-form]');
    if (filterForm) {
      var wrapper = filterForm.closest('[id^="shopify-section-"]');
      var sectionId = wrapper ? wrapper.id.replace('shopify-section-', '') : null;
      var applyButton = filterForm.querySelector('[data-filter-apply]');
      var applyWait = filterForm.querySelector('[data-filter-wait]');
      var latest = 0;

      if (sectionId && applyButton) {
        filterForm.addEventListener('change', function () {
          var params = new URLSearchParams(new FormData(filterForm));
          params.set('section_id', sectionId);
          var mine = (latest += 1);
          applyButton.setAttribute('aria-busy', 'true');
          if (applyWait) applyWait.hidden = false;

          fetch(filterForm.action + '?' + params.toString())
            .then(function (response) { return response.text(); })
            .then(function (html) {
              /* Only the newest answer may paint — ticking three boxes quickly
                 must not settle on whichever request finished last. */
              if (mine !== latest) return;
              var doc = new DOMParser().parseFromString(html, 'text/html');

              var nextButton = doc.querySelector('[data-filter-apply]');
              if (nextButton) {
                applyButton.textContent = nextButton.textContent.trim();
                if (nextButton.hasAttribute('disabled')) applyButton.setAttribute('disabled', '');
                else applyButton.removeAttribute('disabled');
              }

              doc.querySelectorAll('[data-count-for]').forEach(function (next) {
                var current = filterForm.querySelector(
                  '[data-count-for="' + next.getAttribute('data-count-for').replace(/"/g, '\\"') + '"]'
                );
                if (current) current.textContent = next.textContent.trim();
              });
            })
            .catch(function () { /* the form still submits without this */ })
            .then(function () {
              if (mine !== latest) return;
              applyButton.removeAttribute('aria-busy');
              if (applyWait) applyWait.hidden = true;
            });
        });
      }
    }

    var dialog = document.getElementById('filter-drawer');
    if (!dialog) return;

    var openers = document.querySelectorAll('[data-filter-open]');

    openers.forEach(function (opener) {
      opener.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        opener.setAttribute('aria-expanded', 'true');
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', function () {
      openers.forEach(function (opener) {
        opener.setAttribute('aria-expanded', 'false');
      });
    });

    dialog.querySelectorAll('[data-close]').forEach(function (closer) {
      closer.addEventListener('click', function () {
        dialog.close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.querySelector('.contact__form');
    var button = form && form.querySelector('[data-contact-submit]');
    if (!form || !button) return;

    /* `checkValidity()` on each control rather than `form.checkValidity()`:
       `form-validate` sets `novalidate` on the form so the browser stops drawing
       its own bubbles, and on a novalidate form the form-level call still
       reports correctly but says nothing about which control failed — this way
       the same loop can be read and extended.

       The fill answers what has been typed, not what has been touched. An empty
       required field is invalid, so nothing here has to test for emptiness. */
    var controls = form.querySelectorAll('input, textarea');

    var sync = function () {
      for (var i = 0; i < controls.length; i++) {
        var control = controls[i];
        if (control.type === 'hidden' || control.disabled) continue;
        if (!control.checkValidity()) {
          button.classList.remove('is-ready');
          return;
        }
      }
      button.classList.add('is-ready');
    };

    form.addEventListener('input', sync);
    form.addEventListener('change', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    /* --- Input modality: which of the two the shopper is actually using -----
       Paired with the rule in critical.css. The browser's own :focus-visible
       heuristic paints the focus ring on pointer interaction too — on a select
       that has just been clicked, and on whichever element a panel moves focus
       to when it opens. Cleared by the first Tab, arrow or Escape, so a
       keyboard user gets the ring back the moment they use the keyboard. */
    var root = document.documentElement;
    document.addEventListener('pointerdown', function () {
      root.setAttribute('data-pointer', '');
    }, true);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' || event.key === 'Escape' || event.key.indexOf('Arrow') === 0) {
        root.removeAttribute('data-pointer');
      }
    }, true);

    /* --- Nav drawer: a plain element, so the bar stays live while it is open --- */
    var header = document.querySelector('[data-header]');
    var drawer = document.querySelector('[data-nav-drawer]');
    var toggle = document.querySelector('[data-nav-toggle]');

    /* One mechanism, two triggers. The header resolves to white while anything
       is open under it; the panels register here rather than each setting the
       class, so closing one while another is open cannot strand the bar
       transparent over its own sheet. */
    var panels = {};
    var setPanel = function (name, open) {
      if (open) panels[name] = true;
      else delete panels[name];
      var any = false;
      for (var key in panels) {
        if (panels.hasOwnProperty(key)) any = true;
      }
      if (header) header.classList.toggle('header--solid', any);
    };

    if (header && drawer && toggle) {
      var setNav = function (open) {
        /* Deliberately not `setPanel('nav', open)` (owner, 2026-09-07). The bar
           resolved to white while anything opened under it, which was right
           when the menu was a curtain unrolling from the bar itself — the two
           had to read as one surface. The menu is a right-edge drawer now and
           does not touch the bar, so turning the header opaque was dimming a
           photograph for no reason. The cart and search still register, because
           they still unroll from the header. */
        header.classList.toggle('header--nav-open', open);
        drawer.classList.toggle('nav-drawer--open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        /* inert keeps the closed panel out of the tab order and the a11y tree
           without display: none, which would kill the slide transition. */
        if (open) drawer.removeAttribute('inert');
        else drawer.setAttribute('inert', '');
        /* The panel is full-height now, so the page behind it has to hold
           still. The curtain never needed this — it was content-height and the
           live page below it was the point. Measured before adding it: a wheel
           over the scrim scrolled the document 600px with the drawer open.

           Same mechanism the search panel uses, and for the same reason neither
           can use `scroll-lock`: that hook is scoped to `dialog` and `details`,
           and this is neither. */
        document.documentElement.toggleAttribute('data-nav-lock', open);
      };

      var closeNav = function (returnFocus) {
        setNav(false);
        if (returnFocus) toggle.focus();
      };

      toggle.addEventListener('click', function () {
        var open = !header.classList.contains('header--nav-open');
        /* The cart is a modal dialog over everything; unrolling the menu
           underneath it would open a panel nobody can see. */
        if (open) {
          var cart = document.querySelector('cart-drawer');
          if (cart && typeof cart.close === 'function') cart.close();
        }
        setNav(open);
        if (open) {
          var first = drawer.querySelector('a[href]');
          if (first) window.setTimeout(function () { first.focus(); }, 60);
        } else {
          toggle.focus();
        }
      });

      drawer.querySelectorAll('[data-nav-close]').forEach(function (el) {
        el.addEventListener('click', function () { closeNav(true); });
      });

      /* Following a link should not leave the drawer open behind the new page
         in a bfcache restore. */
      drawer.querySelectorAll('a[href]').forEach(function (link) {
        link.addEventListener('click', function () { setNav(false); });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && header.classList.contains('header--nav-open')) closeNav(true);
      });

      /* The panel used to be mobile-only and was force-closed on crossing 1024,
         because above it the bar carried the links itself. It carries none now,
         so the panel is the navigation at every width and a resize past the
         breakpoint is no longer a reason to throw the shopper out of it. */
    }

    /* --- Search: one controller, two surfaces ---------------------------
       The panel unrolls from under the header on wide screens; the sheet takes
       the whole phone. They share every data-search-* hook, so everything below
       works on "the open surface" and never asks which one it is. */
    var panel = document.querySelector('[data-search-panel]');
    var sheet = document.querySelector('[data-search-sheet]');
    var wideSearch = window.matchMedia ? window.matchMedia('(min-width: 768px)') : null;

    if (panel || sheet) {
      var openSearch = null;
      var lastTrigger = null;
      var debounce = null;
      var latest = 0;
      var cache = {};

      /* The empty state is server-rendered; keep a copy so falling back below
         two characters is a restore rather than a second rendering path. */
      var initial = [];
      [panel, sheet].forEach(function (root) {
        if (!root) return;
        initial.push({
          root: root,
          terms: root.querySelector('[data-search-terms]').innerHTML,
          termsLabel: root.querySelector('[data-search-terms-label]').textContent,
          products: root.querySelector('[data-search-products]').innerHTML,
          productsLabel: root.querySelector('[data-search-products-label]').textContent,
        });
      });

      var restore = function (root) {
        waiting(root, false);
        initial.forEach(function (snapshot) {
          if (snapshot.root !== root) return;
          root.querySelector('[data-search-terms]').innerHTML = snapshot.terms;
          root.querySelector('[data-search-terms-label]').textContent = snapshot.termsLabel;
          root.querySelector('[data-search-products]').innerHTML = snapshot.products;
          root.querySelector('[data-search-products-label]').textContent = snapshot.productsLabel;
          var allInitial = root.querySelector('[data-search-all]');
          if (allInitial) allInitial.setAttribute('hidden', '');
        });
      };

      /* SEARCH while the field is empty, CLEAR once there is something to drop.
         One slot, because the two are never both useful at once. */
      var setAction = function (root, hasQuery) {
        var submit = root.querySelector('[data-search-submit]');
        var clear = root.querySelector('[data-search-clear]');
        if (submit) submit.hidden = hasQuery;
        if (clear) clear.hidden = !hasQuery;
      };

      var setSearch = function (root, open) {
        var name = root === sheet ? 'search-sheet' : 'search-panel';
        root.classList.toggle(name + '--open', open);
        var barCloser = document.querySelector('.header__search-close');
        if (barCloser) barCloser.hidden = !open;

        /* The sheet is `position: fixed; inset: 0`, so its own head starts at
           the top of the viewport — behind the bar that now paints over it.
           Measured rather than assumed: the bar's bottom edge moves with the
           announcement strip above it, and with its own height across the
           1024 breakpoint. The desktop panel needs none of this; it is anchored
           to the header's bottom already. */
        if (open) {
          var bar = document.querySelector('[data-header]');
          if (bar) root.style.setProperty('--search-top', Math.round(bar.getBoundingClientRect().bottom) + 'px');
        }

        /* The bar's hairline, hidden for the whole cycle and never animated.
           It is drawn with `transform: scaleX()` off `.header--solid`, and
           opening search resolves the header to solid — so a plain `opacity: 0`
           in CSS still let the line retract left-to-right over 420ms on the way
           out, under a fading overlay. Suppressing the transition from here is
           the only place that can hold it across the close: a class or an
           attribute is gone the instant the panel closes, and the transition
           comes back with it. Cleared a frame after the overlay has finished. */
        var rule = document.querySelector('.header__rule');
        if (rule) {
          if (open) {
            rule.style.transition = 'none';
            rule.style.opacity = '0';
          } else {
            window.setTimeout(function () {
              rule.style.opacity = '';
              window.requestAnimationFrame(function () { rule.style.transition = ''; });
            }, 460);
          }
        }
        if (open) root.removeAttribute('inert');
        else root.setAttribute('inert', '');
        document.querySelectorAll('[data-search-open]').forEach(function (el) {
          el.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        /* The page behind the panel must not move. The panel is positioned
           against the header and its scrim is drawn inside it, so scrolling the
           document slid the dimmed area up the screen and left a grey band
           floating over live content — the scrim cannot follow a page it is not
           attached to. Locking the document is the fix; see assets/critical.css
           for the matching rule. */
        document.documentElement.toggleAttribute('data-search-lock', open);
        /* Both surfaces resolve the bar. The sheet used to cover the header,
           and so this was the panel's alone — but since the overlay rework the
           bar paints above the sheet too, and on the pages where it floats
           (home, collection, cart) a white wordmark and a white close sat on a
           white sheet: search opened onto a header that had vanished. */
        setPanel('search', open);
      };

      var closeSearch = function (returnFocus) {
        if (!openSearch) return;
        setSearch(openSearch, false);
        openSearch = null;
        if (returnFocus && lastTrigger) lastTrigger.focus();
      };

      /* The storefront's price format, in JavaScript — the same one
         `snippets/etree-price.liquid` writes: whole units, a space every three
         digits, currency code last. `3 200 EGP`, never `LE 3,200.00`.

         It used to expand the shop's own money-format string — the one that
         puts LE in front and .00 behind — which made search the last surface
         still printing the platform default while the PDP, the cards and the
         cart had all moved. The two are the same
         rule expressed twice, for the same reason the policy title is: one side
         renders in Liquid, the other from suggest.json in the browser. */
      var money = function (value, code) {
        var amount = parseFloat(value);
        if (isNaN(amount)) return '';
        return String(Math.floor(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ' + code;
      };

      var el = function (tag, className, text) {
        var node = document.createElement(tag);
        if (className) node.className = className;
        if (text != null) node.textContent = text;
        return node;
      };

      /* Handle to [editorial name, colour], written into the page by the Liquid
         above — suggest.json cannot answer with either. Parsed once and never
         refetched: it describes the catalogue, which does not change while a
         shopper is typing. A malformed or missing block leaves an empty map and
         every card falls back to the admin Title, which is what these cards
         printed before this existed. */
      var names = (function () {
        var source = document.querySelector('[data-search-names]');
        if (!source) return {};
        try {
          return JSON.parse(source.textContent) || {};
        } catch (error) {
          return {};
        }
      })();

      /* suggest.json sends a `handle`, but it also sends a `url` that may carry
         a collection prefix or a query string, so the handle is preferred and
         the url is only picked apart when it is missing. */
      var handleOf = function (product) {
        if (product.handle) return product.handle;
        var match = /\/products\/([^/?#]+)/.exec(product.url || '');
        return match ? match[1] : '';
      };

      /* Built as nodes rather than markup: the matched substring has to be
         wrapped in an element, and everything around it is text the shopper
         typed or the catalogue supplied. */
      var highlight = function (text, term, prefix) {
        var fragment = document.createDocumentFragment();
        var at = text.toLowerCase().indexOf(term.toLowerCase());
        if (at < 0) {
          fragment.appendChild(document.createTextNode(text));
          return fragment;
        }
        fragment.appendChild(document.createTextNode(text.slice(0, at)));
        fragment.appendChild(el('mark', prefix + '__mark', text.slice(at, at + term.length)));
        fragment.appendChild(document.createTextNode(text.slice(at + term.length)));
        return fragment;
      };

      /* Which surface, not which shape (owner, 2026-09-11). This used to read a
         `data-search-card` attribute that chose between a card and a 56px row,
         and derived the class prefix from that choice — so the sheet's rail,
         which is cards, would have been built under the panel's names. One card
         shape now, and the prefix comes from the root it is being built for. */
      var prefixFor = function (root) {
        return root === sheet ? 'search-sheet' : 'search-panel';
      };

      var card = function (root, product, format) {
        var prefix = prefixFor(root);
        var link = el('a', prefix + '__card');
        link.href = product.url;

        if (product.featured_image && product.featured_image.url) {
          var image = el('img', prefix + '__card-image');
          /* The CDN url arrives at full resolution — 2700px for a 155px card.
             The sheet's are the wider of the two: 2.2 to a phone is ~155px at
             1x, which a dense screen draws at three times that. */
          image.src = product.featured_image.url +
            (product.featured_image.url.indexOf('?') > -1 ? '&' : '?') +
            'width=' + (root === sheet ? 600 : 400);
          image.alt = '';
          image.loading = 'lazy';
          link.appendChild(image);
        } else {
          link.appendChild(el('span', prefix + '__card-image'));
        }

        /* The editorial name if the page carried one for this handle, the admin
           Title if it did not — a product published between this page loading
           and the shopper typing is the case that falls through, and printing
           its long name is better than printing nothing. */
        var title = el('span', prefix + '__card-title u-name');
        var known = names[handleOf(product)];
        title.appendChild(el('span', prefix + '__card-name', known ? known[0] : product.title));

        /* The swatches `snippets/product-colour.liquid` draws, rebuilt in the
           browser: same classes, same hex custom property, each colour's name
           inside its mark for a screen reader. The title is a flex row, so the
           group lands at the card's right edge the way it does in Liquid. */
        if (known && known[1] && known[1].length) {
          var swatches = el('span', 'colour-swatches ' + prefix + '__card-colour');
          known[1].forEach(function (colour) {
            var swatch = el('span', 'colour-swatch');
            if (colour[1]) swatch.style.setProperty('--swatch', colour[1]);
            swatch.appendChild(el('span', 'visually-hidden', colour[0]));
            swatches.appendChild(swatch);
          });
          title.appendChild(swatches);
        }
        link.appendChild(title);
        link.appendChild(el('span', prefix + '__card-price', money(product.price, format)));

        var item = document.createElement('li');
        item.appendChild(link);
        return item;
      };

      /* The wait for a result set whose shape is already known: the same card or
         row the answer will arrive in, drawn empty. No tag here — a tag says
         "something is coming"; a skeleton says what. */
      var skeleton = function (root) {
        var link = el('span', prefixFor(root) + '__card');
        link.appendChild(el('span', 'etree-skeleton etree-skeleton--image'));

        var title = el('span', 'etree-skeleton etree-skeleton--text');
        var price = el('span', 'etree-skeleton etree-skeleton--text');
        price.style.width = '52%';

        link.appendChild(title);
        link.appendChild(price);

        var item = document.createElement('li');
        item.setAttribute('data-skeleton', '');
        item.appendChild(link);
        return item;
      };

      var waiting = function (root, on) {
        var wait = root.querySelector('[data-search-wait]');
        if (wait) wait.hidden = !on;
        if (!on) return;

        var productsList = root.querySelector('[data-search-products]');
        if (!productsList) return;
        productsList.textContent = '';
        for (var i = 0; i < 4; i += 1) productsList.appendChild(skeleton(root));

        /* The eyebrow above them still reads "1 piece" from the last answer, and
           four skeletons under it make that a count of something else. Put the
           neutral heading back until there is a real number again. */
        initial.forEach(function (snapshot) {
          if (snapshot.root !== root) return;
          root.querySelector('[data-search-products-label]').textContent = snapshot.productsLabel;
        });
      };

      var paint = function (root, term, data) {
        waiting(root, false);
        var results = (data && data.resources && data.resources.results) || {};
        var queries = results.queries || [];
        var products = results.products || [];
        var format = root.getAttribute('data-currency') || '';
        var termsList = root.querySelector('[data-search-terms]');
        var productsList = root.querySelector('[data-search-products]');
        var prefix = root === sheet ? 'search-sheet' : 'search-panel';

        /* Query suggestions come from the shop's own search history, so a young
           store returns none. Rather than an empty column under an empty
           eyebrow, the popular searches stay — they are still somewhere to go. */
        if (queries.length) {
          root.querySelector('[data-search-terms-label]').textContent =
            root.getAttribute('data-label-suggestions');
          termsList.textContent = '';
          queries.forEach(function (query) {
            var link = el('a', prefix + '__term');
            link.href = query.url;
            link.appendChild(highlight(query.text, term, prefix));
            var item = document.createElement('li');
            item.appendChild(link);
            termsList.appendChild(item);
          });
        }

        var pieces = products.length === 1
          ? root.getAttribute('data-label-pieces-one')
          : root.getAttribute('data-label-pieces-other');
        root.querySelector('[data-search-products-label]').textContent =
          (pieces || '').replace('[n]', products.length);
        productsList.textContent = '';
        products.forEach(function (product) {
          productsList.appendChild(card(root, product, format));
        });

        /* The search route comes off the form rather than from Liquid: this is
           a javascript tag, and Liquid is not rendered inside one. */
        /* Removed from both surfaces on 2026-09-10 — a link to a page that says
           the same thing the panel is already showing. Guarded rather than
           deleted: the hook is cheap to keep and a future surface may want it. */
        var all = root.querySelector('[data-search-all]');
        if (all) {
          var form = root.querySelector('form[action]');
          all.href = (form ? form.getAttribute('action') : '/search') + '?q=' + encodeURIComponent(term) + '&type=product';
          if (products.length || queries.length) all.removeAttribute('hidden');
          else all.setAttribute('hidden', '');
        }
      };

      var query = function (root, term) {
        window.clearTimeout(debounce);
        if (term.length < 2) {
          latest += 1;
          restore(root);
          return;
        }

        /* Already answered this session: paint now. Backspacing and retyping is
           most of what happens in a search field, and none of it should cost a
           round trip. */
        if (cache[term]) {
          latest += 1;
          paint(root, term, cache[term]);
          return;
        }

        var run = function () {
          var seq = (latest += 1);
          waiting(root, true);
          var url =
            '/search/suggest.json?q=' + encodeURIComponent(term) +
            '&resources[type]=product,query&resources[limit]=4' +
            '&resources[options][unavailable_products]=last';
          fetch(url, { headers: { Accept: 'application/json' } })
            .then(function (response) { return response.json(); })
            .then(function (data) {
              cache[term] = data;
              /* A slower earlier request must never overwrite a newer answer. */
              if (seq !== latest) return;
              paint(root, term, data);
            })
            .catch(function () {
              /* The form still submits to /search. Put the wait away either way:
                 a skeleton left standing is a promise the panel cannot keep. */
              if (seq === latest) restore(root);
            });
        };

        /* The first query of a session goes on the leading edge. Waiting 200ms
           for it buys nothing — there is no earlier request to coalesce with —
           and it is the one wait the shopper actually notices, because the
           column below is still showing the empty state. Every keystroke after
           it is debounced as normal. */
        if (term.length === 2) run();
        else debounce = window.setTimeout(run, 200);
      };

      [panel, sheet].forEach(function (root) {
        if (!root) return;

        root.querySelectorAll('[data-search-close]').forEach(function (closer) {
          closer.addEventListener('click', function () { closeSearch(true); });
        });

        var input = root.querySelector('[data-search-input]');
        if (input) {
          input.addEventListener('input', function () {
            var term = input.value.trim();
            setAction(root, term.length > 0);
            query(root, term);
          });
        }

        /* Nothing typed, nothing submitted (owner, 2026-09-11). Enter on an
           empty field posted the form anyway and landed on `/search?q=`, a
           results page for a question nobody asked — it has a state drawn for
           it, which is a fallback, not a destination.

           Trimmed, so a field holding three spaces is empty too, and the value
           is written back so a query with spaces either side does not carry
           them into the URL and the result heading.

           No message: the field is where the shopper already is and the caret
           is already in it. An error under an empty box would be the storefront
           telling someone off for not having started yet. */
        var form = root.querySelector('form[action]');
        if (form && input) {
          form.addEventListener('submit', function (event) {
            var term = input.value.trim();
            if (!term) {
              event.preventDefault();
              input.focus();
              return;
            }
            input.value = term;
          });
        }

        var clear = root.querySelector('[data-search-clear]');
        if (clear && input) {
          clear.addEventListener('click', function () {
            input.value = '';
            setAction(root, false);
            query(root, '');
            input.focus();
          });
        }

        /* Focus stays inside the open surface; the page behind it is not a
           place to arrive by Tab. */
        root.addEventListener('keydown', function (event) {
          if (event.key !== 'Tab') return;
          var focusable = root.querySelectorAll(
            'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
          );
          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });
      });

      /* The bar's closer is outside either root — it lives in the header so it can
         take the slot the icons vacate — so it is bound once, here, rather than
         inside the per-root loop that would bind it twice.

         `closeSearch`, not `setSearch`. The first version called `setSearch`
         directly and left `openSearch` still pointing at the panel, so the next
         press of the magnifier was read as "close what is already open" and did
         nothing visible: search took two clicks to reopen. Every other closer
         goes through `closeSearch`; this one had quietly opted out. */
      var barCloser = document.querySelector('.header__search-close');
      if (barCloser) {
        barCloser.addEventListener('click', function () { closeSearch(true); });
      }

      document.querySelectorAll('[data-search-open]').forEach(function (opener) {
        opener.addEventListener('click', function () {
          /* The control that opened it closes it. Without this the magnifier is
             the one thing on the bar that does nothing when pressed. */
          if (openSearch) {
            closeSearch(true);
            return;
          }
          var wide = wideSearch ? wideSearch.matches : true;
          var root = wide && panel ? panel : sheet || panel;
          if (!root) return;
          lastTrigger = opener;
          /* Opened from the menu: the menu has done its job and the sheet is
             about to cover it anyway. */
          if (typeof closeNav === 'function') closeNav(false);
          openSearch = root;
          setSearch(root, true);
          var input = root.querySelector('[data-search-input]');
          setAction(root, !!(input && input.value.trim()));
          if (input) window.setTimeout(function () { input.focus(); }, 120);
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeSearch(true);
      });

      /* Crossing the breakpoint with search open would leave the hidden surface
         holding the state and the visible one empty. */
      if (wideSearch) {
        var onResize = function () { closeSearch(false); };
        if (wideSearch.addEventListener) wideSearch.addEventListener('change', onResize);
        else if (wideSearch.addListener) wideSearch.addListener(onResize);
      }
    }
  })();

  /* Pinning the overlay header. Interior pages are `position: sticky` and need
     no script at all; the homepage bar is lifted out of flow so the hero can run
     behind it, and an absolutely positioned element has nothing to stick to.

     A 1px sentinel is dropped where the header sits in the document and watched
     with IntersectionObserver, rather than reading scrollY on every scroll
     event: the threshold is then the header's real position rather than a
     number that has to be kept in step with the announcement bar's height. */
  (function () {
    var header = document.querySelector('[data-header]');
    if (!header || !header.classList.contains('header--overlay')) return;
    if (!('IntersectionObserver' in window)) return;

    var sentinel = document.createElement('span');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none';
    header.parentNode.insertBefore(sentinel, header);

    new IntersectionObserver(
      function (entries) {
        header.classList.toggle('header--stuck', !entries[0].isIntersecting);
      },
      { threshold: 0 }
    ).observe(sentinel);
  })();

  /* The bar gets out of the footer's way. The footer closes with the wordmark
     and a pinned header carries the same mark, so without this the page ends
     with two of them on one screen.

     It watches the wordmark itself, not the footer's top edge (owner,
     2026-09-07). The footer opens with the newsletter and closes with the mark
     ~450px lower, so watching the top hid the bar for most of the scroll on any
     short page — the cart page lost it at ~50px — to avoid a collision that was
     still half a screen away. Watching the mark makes the trigger the thing the
     rule is actually about.

     Watching an element rather than a scroll position for the same reason the
     sentinel above does: the threshold stays correct however tall the footer
     grows. `rootMargin` fires it a little early so the bar has finished leaving
     before the mark arrives rather than crossing it on the way out.

     Runs on every page, not just the overlay ones — interior headers are
     `position: sticky` and have exactly the same problem.

     The footer being visible is necessary but not sufficient: the bar also has
     to be pinned, i.e. the page has to be scrolled. Without that second half,
     any page short enough to show its own footer at rest — the cart, first of
     all, at 1273px in a 900px window — tucked its header away on load and never
     got it back, because a page that short never fires the intersection again.
     There was no header and no way to scroll to one (owner, 2026-09-07).

     At scrollY 0 the header is in normal flow at the top of the document, so
     two wordmarks on one screen there is the page's own proportions rather than
     something the pinning did, and hiding the bar is not ours to do. */
  (function () {
    var header = document.querySelector('[data-header]');
    /* The mark, with the footer as the fallback — a footer configured without
       its bottom row still deserves the behaviour, just at the older threshold. */
    var footer = document.querySelector('.footer__mark') || document.querySelector('footer[role="contentinfo"]');
    if (!header || !footer) return;
    if (!('IntersectionObserver' in window)) return;

    var footerVisible = false;

    /* Never while something is open under it. Tucking the bar with the search
       panel unrolled from it would take the panel along, and the shopper would
       watch their own query slide off the top. */
    var apply = function () {
      if (header.classList.contains('header--solid')) return;
      header.classList.toggle('header--tucked', footerVisible && window.scrollY > 0);
    };

    new IntersectionObserver(
      function (entries) {
        footerVisible = entries[0].isIntersecting;
        apply();
      },
      { rootMargin: '0px 0px -40px 0px', threshold: 0 }
    ).observe(footer);

    /* The observer alone cannot bring the bar back on a short page: the footer
       never stops intersecting, so nothing fires on the way up. */
    window.addEventListener('scroll', apply, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-product]');
    if (!root) return;

    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = root.querySelector('[data-variant-id]');
    /* Plural: the price now rides both the inline button and the sticky one,
       and a singular query would have left the sticky bar showing the price of
       whichever variant the page opened on. */
    var priceEls = root.querySelectorAll('[data-price]');
    var addButton = root.querySelector('[data-add-button]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var sizeError = root.querySelector('[data-size-error]');
    var bar = root.querySelector('[data-buybar]');
    var barPrice = root.querySelector('[data-buybar-price]');
    var barOption = root.querySelector('[data-buybar-option]');
    var addLabels = root.querySelectorAll('[data-add-label]');
    var strings = {
      add: root.getAttribute('data-add-text') || 'Add to bag',
      selectSize: root.getAttribute('data-select-size') || 'Select size',
      chooseSize: root.getAttribute('data-choose-size') || 'Please choose your size',
      soldOut: root.getAttribute('data-sold-out') || 'Sold out',
      unavailable: root.getAttribute('data-unavailable') || 'Unavailable'
    };

    function selectedOptions() {
      var fieldsets = root.querySelectorAll('[data-option-position]');
      var values = [];
      fieldsets.forEach(function (fs) {
        var pos = parseInt(fs.getAttribute('data-option-position'), 10);
        var checked = fs.querySelector('[data-option-input]:checked');
        values[pos - 1] = checked ? checked.value : null;
      });
      return values;
    }

    function matchVariant(values) {
      return variants.find(function (v) {
        return v.options.length === values.length && v.options.every(function (opt, i) {
          return opt === values[i];
        });
      });
    }

    function updateActiveClasses() {
      root.querySelectorAll('.swatch').forEach(function (el) {
        var input = el.querySelector('[data-option-input]');
        el.classList.toggle('swatch--active', input && input.checked);
      });
      root.querySelectorAll('.size-pill').forEach(function (el) {
        var input = el.querySelector('[data-option-input]');
        el.classList.toggle('size-pill--active', input && input.checked);
      });
    }

    /* Which sizes exist in the colour now selected — the struck-through row.
       Liquid can only answer "available in some variant"; this answers it for
       the combination on screen, which is the question the shopper is asking.
       Any option the row does not itself set is held at its current value, so a
       size is struck only when THIS colour has none of it. */
    function updateAvailability() {
      var current = selectedOptions();

      root.querySelectorAll('[data-option-position]').forEach(function (fieldset) {
        var position = parseInt(fieldset.getAttribute('data-option-position'), 10);
        if (!position) return;

        fieldset.querySelectorAll('[data-option-input]').forEach(function (input) {
          var candidate = current.slice();
          candidate[position - 1] = input.value;

          var match = variants.find(function (v) {
            return v.options.every(function (opt, i) {
              return candidate[i] === null || candidate[i] === undefined || opt === candidate[i];
            });
          });

          var sellable = !!(match && match.available);
          var pill = input.closest('.size-pill');

          /* A disabled radio cannot be unchecked by the customer, but it can
             already be the checked one — arriving on a sold-out variant by URL.
             Disabling it then would strand the page with no selection, so the
             selected control always stays operable; the button carries the
             SOLD OUT. */
          if (!input.checked) input.disabled = !sellable;
          if (pill) pill.classList.toggle('size-pill--unavailable', !sellable);
        });
      });
    }

    function updateSelectedLabels() {
      root.querySelectorAll('[data-option-position]').forEach(function (fs) {
        var checked = fs.querySelector('[data-option-input]:checked');
        var label = fs.querySelector('[data-selected-value]');
        var sep = fs.querySelector('[data-selected-sep]');
        if (label) label.textContent = checked ? checked.value : '';
        if (sep) sep.hidden = !checked;
      });

      if (!barOption) return;
      var position = barOption.getAttribute('data-buybar-position');
      var fieldset = root.querySelector('fieldset[data-option-position="' + position + '"]');
      var selected = fieldset ? fieldset.querySelector('[data-option-input]:checked') : null;
      if (!selected) return;
      var format = barOption.getAttribute('data-summary-format') || '%v';
      barOption.textContent = format.replace('%v', selected.value);
    }

    /* The size guide opens on the size the shopper is looking at, and follows it
       while the panel is open. Written as an attribute rather than a call into
       the panel's controller: neither side then has to hold a reference to the
       other, and a page with no size option simply never writes it. */
    function syncSizeGuide() {
      var panel = document.querySelector('[data-size-guide]');
      if (!panel) return;

      /* The size fieldset is the one holding the pills, not the one whose legend
         reads "Size" — a colourway called Sable would not be caught by a name
         test, and the markup already says which is which. */
      var sizes = root.querySelector('.buybox__sizes');
      var checked = sizes ? sizes.querySelector('[data-option-input]:checked') : null;
      if (checked) panel.setAttribute('data-active-size', checked.value);
    }

    /* Three states, decided by where the real button is rather than by a scroll
       distance: a long description or a short one moves that button, and a
       threshold in pixels gets it wrong on one of them.

         button below the viewport  -> floating, at the bottom
         button on screen           -> hidden; the real one is doing the job
         button above the viewport  -> pinned, at the top, with the name

       The third state is the one that earns its keep. `isIntersecting` alone
       cannot tell "not reached yet" from "already passed" — both are false — so
       the sign of the button's own top edge is what separates them. */
    /* Only write when the mode actually changes. This runs from a scroll
       listener, so the unguarded version rewrote the same three classes on
       essentially every frame — measured on a 4x-throttled phone: 40 redundant
       writes against 2 real transitions across a full-page scroll. Each one
       dirties the element and wakes anything observing it. It was not dropping
       frames, but it was work done for nothing sixty times a second, and it is
       the kind of cost that stops being free on a cheaper device. */
    var currentMode = null;
    function setBarMode(mode) {
      if (!bar || mode === currentMode) return;
      currentMode = mode;
      if (mode === 'hidden') {
        bar.classList.add('is-hidden');
        return;
      }
      bar.classList.toggle('buybar--floating', mode === 'floating');
      bar.classList.toggle('buybar--pinned', mode === 'pinned');
      bar.classList.remove('is-hidden');
    }

    /* `matchMedia` rather than reading a custom property off computed style.
       `--floating-bar` was a media query wearing a disguise — it existed only
       so CSS could tell JS which band it was in — and resolving it cost a style
       lookup on every floating frame.

       The band is the TABLET one, 744-1023.98, where the floating state is
       deliberately off (see the note on the tablet band). It is not "below
       1024": phones are inside the allowed range and so is desktop, where the
       bar is display:none anyway. Getting this inverted would put a floating
       button back on tablets, which is a decision that was made against.

       This query and the `--floating-bar` declarations above must not drift;
       the property is kept as the single source of that number. */
    var tabletBand = window.matchMedia('(min-width: 744px) and (max-width: 1023.98px)');
    function floatingAllowed() {
      return !tabletBand.matches;
    }

    /* Where the floating button's own top edge sits. Measured once from the bar
       in its floating state — which is how it is rendered — rather than assumed
       from the CSS, and taken again on resize. */
    var floatHeight = 0;
    function measureFloat() {
      if (bar && bar.classList.contains('buybar--floating')) floatHeight = bar.offsetHeight;
    }

    /* The hand-off happens where the two buttons coincide, not where the real
       one merely arrives on screen.

       Swapping on "is it visible" left both on screen at once: the floating
       button sits at the bottom of the viewport, so the real one enters below
       it and the two are up together for the ~60px it takes to climb past.
       Swapping when the real button reaches the floating one's line means they
       are never both painted, and because they are the same button at the same
       size at the same place, the exchange reads as the floating one arriving
       and stopping. */
    function syncBar() {
      if (!bar || !addButton) return;

      /* Above 1024 the bar is display:none and the buy box is sticky, so the
         real button must never be stood down for it. */
      if (window.getComputedStyle(bar).display === 'none') {
        addButton.classList.remove('buybox__add--deferred');
        return;
      }

      var r = addButton.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var mode = r.bottom <= 0
        ? 'pinned'
        : (r.top > vh - floatHeight ? 'floating' : 'hidden');

      /* Tablets take the whole photograph rather than a button over it. The
         picture is 3:4 and the screen is not, so on an iPad Air the image ends
         at y1093 and the name lands at y1117 — inside a floating button's band,
         occluded rather than merely below the fold. Cropping the garment to win
         that back was tried and rejected: neither reference does it, and Gucci
         ships no floating button on a tablet at all. The name falls below the
         fold there, one short scroll away, and the real button is right behind
         it.

         The pinned state is untouched — that one still earns its place. */
      if (mode === 'floating' && !floatingAllowed()) mode = 'hidden';

      /* While the floating button is standing in for the real one, the real one
         is not painted. Otherwise it climbs into the gap beneath the float and
         the two are on screen together for the 16px it takes to get behind it.
         It keeps its space, so nothing moves at the swap — the float vanishes
         at the exact moment and place the real one appears, which is what makes
         the exchange read as the button arriving and stopping. */
      addButton.classList.toggle('buybox__add--deferred', mode === 'floating');
      setBarMode(mode);
    }

    function watchInlineButton() {
      if (!bar || !addButton) return;

      /* The observer carries the ordinary case cheaply. It is not enough on its
         own: a jump straight from the top of the page to below the button —
         a restored scroll position, a back-navigation, an anchor — leaves the
         intersection ratio at 0 the whole way, so nothing fires and the bar
         stays in whichever state it was left in. A passive scroll listener,
         coalesced onto a frame, closes that. */
      if (typeof IntersectionObserver === 'function') {
        new IntersectionObserver(syncBar, { rootMargin: '0px 0px -8px 0px' }).observe(addButton);
      }

      var queued = false;
      function onScroll() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
          queued = false;
          syncBar();
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measureFloat(); onScroll(); }, { passive: true });

      measureFloat();
      syncBar();
    }

    /* The drawer marks the inline button busy for the length of the add request
       (sections/cart-drawer.liquid). The bar's button is outside the form it
       submits, so it is not the one the drawer finds — it follows along here
       instead of running a second timer of its own. */
    function mirrorBusyState() {
      if (!stickyAdd || !addButton || typeof MutationObserver !== 'function') return;

      new MutationObserver(function () {
        if (addButton.getAttribute('aria-busy') === 'true') {
          stickyAdd.setAttribute('aria-busy', 'true');
        } else {
          stickyAdd.removeAttribute('aria-busy');
        }
      }).observe(addButton, { attributes: true, attributeFilter: ['aria-busy'] });
    }

    var gallery = root.querySelector('[data-gallery]');
    var rail = root.querySelector('[data-gallery-rail]');
    var tick = root.querySelector('[data-gallery-tick]');
    var countEl = root.querySelector('[data-gallery-count]');
    var countFormat = rail ? rail.getAttribute('data-count-format') || '%c / %t' : '%c / %t';

    function visibleSlides() {
      if (!gallery) return [];
      return Array.prototype.filter.call(gallery.children, function (el) {
        return !el.hidden;
      });
    }

    // Slide width is the track width, so the index is the scroll offset over one
    // viewport — no observer, no library. The count comes from the visible
    // slides, not the rendered ones: filtering by colour changes the total.
    function syncCounter() {
      if (!gallery || !rail || !tick || !countEl) return;

      var total = visibleSlides().length;
      rail.hidden = total < 2;
      if (total < 2) return;

      var index = 0;
      if (gallery.clientWidth) {
        index = Math.round(gallery.scrollLeft / gallery.clientWidth);
      }
      if (index < 0) index = 0;
      if (index > total - 1) index = total - 1;

      tick.style.width = 100 / total + '%';
      tick.style.transform = 'translateX(' + index * 100 + '%)';
      countEl.textContent = countFormat
        .replace('%c', String(index + 1))
        .replace('%t', String(total));
    }

    if (gallery) {
      gallery.addEventListener('scroll', syncCounter, { passive: true });
      window.addEventListener('resize', syncCounter);
    }

    // Media carrying no [data-media-colour] name no colour in their alt text —
    // detail shots — and stay visible for every colour.
    function filterGallery() {
      if (!gallery) return;
      var checked = root.querySelector('[data-option-colour] [data-option-input]:checked');
      if (!checked) return;

      var colour = checked.value.toLowerCase();
      var items = gallery.querySelectorAll('[data-media-colour]');
      if (!items.length) return;

      var hasMatch = false;
      items.forEach(function (el) {
        if (el.getAttribute('data-media-colour') === colour) hasMatch = true;
      });

      items.forEach(function (el) {
        el.hidden = hasMatch && el.getAttribute('data-media-colour') !== colour;
      });

      // A new colour is a new gallery — leaving the track parked on slide four
      // of the old one shows a different garment than the swatch just picked.
      gallery.scrollLeft = 0;
    }

    /* Is there a size left to buy at all, for the colour currently chosen?
       updateAvailability() disables the pills that have gone, so the row itself
       is the answer. A product with no size option is always sellable. */
    function anySellableSize() {
      var sizes = root.querySelector('.buybox__sizes');
      if (!sizes) return true;
      return !!sizes.querySelector('[data-option-input]:not(:disabled)');
    }

    /* The first option fieldset with nothing checked, or null once every option
       has an answer. */
    function unchosenFieldset() {
      var pending = null;
      root.querySelectorAll('[data-option-position]').forEach(function (fs) {
        if (pending) return;
        if (!fs.querySelector('[data-option-input]:checked')) pending = fs;
      });
      return pending;
    }

    /* Take the shopper to the decision instead of reporting that they have not
       made it. Both buttons submit the same form, so both are intercepted. */
    function clearSizeError() {
      if (sizeError) sizeError.hidden = true;
    }

    function interceptWithoutSize() {
      [addButton, stickyAdd].forEach(function (button) {
        if (!button) return;
        button.addEventListener('click', function (event) {
          var pending = unchosenFieldset();
          if (!pending) return;
          event.preventDefault();

          /* Say it, do not only move. Scrolling to the row answers "where",
             but a shopper who pressed Add to bag asked to buy — being moved
             somewhere without being told why reads as the button failing.
             The message is set here rather than left in the markup so it is
             never in the page for a shopper who has not earned it. */
          if (sizeError) {
            sizeError.textContent = strings.chooseSize;
            sizeError.hidden = false;
          }

          pending.scrollIntoView({ block: 'center', behavior: 'smooth' });
          var first = pending.querySelector('[data-option-input]:not(:disabled)');
          if (first) first.focus({ preventScroll: true });
        });
      });
    }

    function setAddState(disabled, label, choosing) {
      [addButton, stickyAdd].forEach(function (button) {
        if (!button) return;
        button.disabled = disabled;
        /* The bag icon belongs to "Add to bag". Beside "Select size" it
           illustrates an action the press does not perform. */
        button.classList.toggle('buybox__add--choosing', !!choosing);
      });
      addLabels.forEach(function (el) {
        el.textContent = label;
      });
    }

    function onChange() {
      /* The error is answered by the act of choosing, so it clears on any
         option change rather than waiting for the next press. */
      if (!unchosenFieldset()) clearSizeError();
      updateActiveClasses();
      updateSelectedLabels();
      updateAvailability();
      filterGallery();
      syncCounter();
      syncSizeGuide();

      /* Sold out beats every other state. updateAvailability() has just re-marked
         the row against the chosen colour, so if nothing in it is selectable
         there is nothing to choose — and a button reading "Select size" over
         four dead pills sends the shopper to a decision that cannot be made. */
      if (!anySellableSize()) {
        setAddState(true, strings.soldOut);
        return;
      }

      /* Nothing chosen yet is not the same as nothing available. Before the
         shopper has picked a size the button stays live and names the next
         step, and pressing it takes them to the row rather than failing. An
         error after a refused tap tells you what a label could have said
         first. */
      /* The button keeps saying "Add to bag", with its price, even before a
         size is chosen (owner, 2026-09-03). "Select size" as the resting label
         made the price disappear and put an instruction where the action
         belongs — and on a phone, where there is no hover, it was the only face
         the button ever had. It now appears on pointer hover only; a press
         still routes to the size row either way, via interceptWithoutSize(). */
      if (unchosenFieldset()) {
        setAddState(false, strings.add, true);
        return;
      }

      var variant = matchVariant(selectedOptions());

      if (!variant) {
        setAddState(true, strings.unavailable);
        return;
      }

      if (idInput) idInput.value = variant.id;
      priceEls.forEach(function (el) { el.textContent = variant.price; });
      if (barPrice) barPrice.textContent = variant.price;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      setAddState(!variant.available, variant.available ? strings.add : strings.soldOut);
    }

    root.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', onChange);
    });

    updateAvailability();
    onChange();
    interceptWithoutSize();
    watchInlineButton();
    mirrorBusyState();
    syncCounter();
    syncSizeGuide();
  })();

  /* The desktop gallery deck: one photograph at a time in a viewport-tall
     sticky column, with dots down the right edge to jump (owner, 2026-09-05).

     The movement is the browser's: the column is a scroll container with
     `scroll-snap-type: y mandatory`, so a wheel over it scrolls it exactly the
     way a wheel scrolls anything, one snap point per gesture, and when it runs
     out at either end the scroll chains to the page on its own. Nothing here
     calls `preventDefault`. An earlier build did, and swapped opacity between
     shots — it faded, and a trackpad's tail of small deltas crossed several
     photographs on a single flick.

     This script therefore does no scrolling. It builds the dots, reports which
     photograph is in view, and scrolls to one when a dot is pressed.

     `.is-deck` is added here, and every deck rule is behind it, so a browser
     with no JS keeps the stacked column with every photograph reachable. */
  (function () {
    var col = document.querySelector('.product__gallery-col');
    var gallery = col && col.querySelector('[data-gallery]');
    var dots = col && col.querySelector('[data-gallery-dots]');
    if (!col || !gallery) return;

    var desktop = window.matchMedia('(min-width: 1024px)');
    var index = 0;

    function slides() {
      return Array.prototype.filter.call(gallery.children, function (el) {
        return !el.hasAttribute('hidden');
      });
    }

    function paint() {
      if (!dots) return;
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    /* Read from scrollTop rather than tracked in a variable: the shopper moves
       this container directly, so its scroll position is the only truth about
       which photograph is in view.

       Measured against each slide's own top, not against a fixed step — the
       slides are as tall as their photographs, so `scrollTop / clientHeight`
       stopped meaning anything the moment they became taller than the column.
       The one in view is the last one whose top has passed the fold line. */
    function readIndex() {
      var list = slides();
      if (!list.length) return;
      var mark = gallery.scrollTop + 1;
      var next = 0;
      for (var i = 0; i < list.length; i++) {
        if (list[i].offsetTop <= mark) next = i;
      }
      if (next === index) return;
      index = next;
      paint();
    }

    function buildDots() {
      if (!dots) return;
      var list = slides();
      dots.innerHTML = '';
      if (list.length < 2) {
        dots.hidden = true;
        return;
      }
      dots.hidden = false;
      list.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product__dot';
        dot.setAttribute('aria-label', String(i + 1));
        dot.addEventListener('click', function () {
          gallery.scrollTo({ top: slide.offsetTop, behavior: 'smooth' });
        });
        dots.appendChild(dot);
      });
    }

    /* Measured, not hardcoded: the header is 84px today and the grid's padding
       24px, and both are values someone will change without thinking about this
       file. Read before the class is added, so the numbers are the ones from
       the untouched layout. */
    function measure() {
      var header = document.querySelector('[data-header]');
      var headerH = header ? Math.round(header.getBoundingClientRect().height) : 0;
      /* The bar floats over the photograph at every width now (owner,
         2026-09-13), so the column is a whole screenful measured from the top
         of the window and pulled all the way up to it. Read from the computed
         position rather than assumed, so a header put back in flow brings the
         old arithmetic back with it. `fixed` counts: a page reloaded
         mid-scroll measures with the bar already pinned. */
      var floats = header && getComputedStyle(header).position !== 'relative' && getComputedStyle(header).position !== 'static';
      var top = floats ? 0 : headerH;
      /* Where the column sits unpulled. Measured a second time with the deck
         on, it is already pulled up by the last value, and reading that as its
         resting place would set the pull to zero and drop it straight back. */
      var pulled = col.classList.contains('is-deck') ? parseFloat(col.style.getPropertyValue('--deck-pull')) || 0 : 0;
      var colTop = Math.round(col.getBoundingClientRect().top + window.scrollY + pulled);
      col.style.setProperty('--deck-top', top + 'px');
      col.style.setProperty('--deck-pull', Math.max(0, colTop - top) + 'px');
      /* The grid track is sized from the same number, and the track belongs to
         the parent, so it needs its own copy. */
      if (col.parentElement) col.parentElement.style.setProperty('--deck-top', top + 'px');
      centreBuybox(headerH);
    }

    /* The buy box sits at the vertical middle of the screen beside the
       photograph rather than at its top (owner, 2026-09-13) — a name hung at
       the head of a screen-tall picture is half of what made the page read as
       lopsided on a wide window.

       Measured once per layout, not kept centred: an accordion opening grows
       the box, and re-centring it would lift the name the shopper is reading.
       It grows downwards from where it was put. The floor keeps the name 24px
       clear of the floating bar on a short window. */
    function centreBuybox(headerH) {
      var product = col.parentElement;
      var box = product && product.querySelector('.product__buybox');
      if (!box) return;
      var current = parseFloat(getComputedStyle(box).marginBlockStart) || 0;
      var rest = box.getBoundingClientRect().top + window.scrollY - current;
      var floor = headerH + 24;
      /* The middle of the photograph where it is shorter than the window —
         a tall portrait window, where the column's 60vw cap binds — and of
         the window otherwise. */
      var deck = col.querySelector('.product__deck');
      var frame = Math.min(window.innerHeight, deck ? deck.offsetHeight : window.innerHeight);
      var centred = (frame - box.offsetHeight) / 2;
      product.style.setProperty('--buybox-drop', Math.round(Math.max(floor, centred) - rest) + 'px');
    }

    function enable() {
      measure();
      col.classList.add('is-deck');
      if (col.parentElement) col.parentElement.classList.add('is-deck');
      /* Again, now the deck's layout applies: the buy box stops being sticky
         here, and a sticky box on a scrolled page reports where it is pinned
         rather than where it sits. */
      measure();
      buildDots();
      index = 0;
      paint();
    }

    function disable() {
      col.classList.remove('is-deck');
      if (col.parentElement) col.parentElement.classList.remove('is-deck');
      if (dots) {
        dots.hidden = true;
        dots.innerHTML = '';
      }
    }

    function sync() {
      if (desktop.matches) enable();
      else disable();
    }

    gallery.addEventListener('scroll', readIndex, { passive: true });

    /* The column and the buy box both answer to the window's height, which
       changes without crossing the breakpoint — a resized window, a docked
       devtools panel. */
    var resizeFrame = 0;
    window.addEventListener('resize', function () {
      if (!col.classList.contains('is-deck')) return;
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(measure);
    });

    if (desktop.addEventListener) desktop.addEventListener('change', sync);
    else if (desktop.addListener) desktop.addListener(sync);

    /* A colour filter hides and shows slides, so the dots have to be rebuilt
       from whatever is visible now rather than from what was there at load. */
    new MutationObserver(function () {
      if (!col.classList.contains('is-deck')) return;
      buildDots();
      gallery.scrollTop = 0;
      index = 0;
      paint();
    }).observe(gallery, { attributes: true, subtree: true, attributeFilter: ['hidden'] });

    sync();
  })();

  /* The accordions' open/close behaviour is `snippets/accordion.liquid`,
     rendered beside the markup above. It moved there on 2026-09-07 because a
     section-level script block is compiled per section and gated on that
     section being rendered — `if (!__sections__["product"]) return;` in the bundle — so the
     cart page's help panels got the CSS (which is not gated) and none of the
     script. They opened onto a panel that never grew.

     Only the behaviour moved. The `.accordion` CSS stays in this file's
     stylesheet on purpose: the desktop override below it is `padding-block: 0`
     inside a media query, which beats the base rule by source order alone, and
     source order between a snippet's stylesheet and a section's is not
     guaranteed. Splitting them would decide that override by luck. */


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-related]');
    if (!section) return;

    var track = section.querySelector('[data-related-grid]');
    var prev = section.querySelector('[data-related-prev]');
    var next = section.querySelector('[data-related-next]');
    var bar = section.querySelector('[data-related-progress]');

    // The arrows sit on the photograph, and the photograph's height is a ratio
    // of a column width that is itself a percentage of the viewport. Measuring
    // it is one read; deriving it in CSS would mean restating the aspect ratio
    // and the column arithmetic in a second place where they could drift.
    function measure() {
      if (!track) return;
      var well = track.querySelector('.product-card__well');
      if (well) {
        section.style.setProperty('--rp-well-h', Math.round(well.getBoundingClientRect().height) + 'px');
      }
      sync();
    }

    // A card and a gap. Advancing a whole viewport skips past products the
    // shopper has not looked at yet; a related row is short enough that a step
    // is the right size of step.
    function step() {
      if (!track) return 0;
      var item = track.firstElementChild;
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function sync() {
      if (!track) return;
      // 1px of slack: sub-pixel column widths leave scrollWidth a hair over
      // clientWidth on rows that visibly do not scroll.
      var max = track.scrollWidth - track.clientWidth;
      var overflows = max > 1;
      section.setAttribute('data-overflow', overflows ? 'true' : 'false');

      var left = track.scrollLeft;
      if (prev) prev.hidden = !overflows || left <= 1;
      if (next) next.hidden = !overflows || left >= max - 1;

      if (bar) {
        var span = track.clientWidth / track.scrollWidth;
        var offset = max > 0 ? (left / max) * (1 - span) : 0;
        bar.style.width = (span * 100).toFixed(3) + '%';
        bar.style.marginInlineStart = (offset * 100).toFixed(3) + '%';
      }
    }

    function go(direction) {
      if (!track) return;
      track.scrollBy({ left: direction * step(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    if (track) track.addEventListener('scroll', sync, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(measure).observe(section);
    } else {
      window.addEventListener('resize', measure);
    }
    measure();

    var url = section.getAttribute('data-recs-url');
    var productId = section.getAttribute('data-product-id');
    var sectionId = section.getAttribute('data-section-id');
    var limit = section.getAttribute('data-limit') || '5';
    if (!url || !productId) return;

    var endpoint = url + '?section_id=' + encodeURIComponent(sectionId) +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(limit) +
      '&intent=related';

    fetch(endpoint)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var incoming = doc.querySelector('[data-related-grid]');
        if (!incoming || !track) return;
        // Only swap in recommendations when there are some. An empty response is
        // normal on a young store, and the server-rendered same-collection
        // fallback is already in the grid — don't hide the section over it.
        if (incoming.children.length > 0) {
          track.innerHTML = incoming.innerHTML;
          // The row is a different length now, so the arrows and the bar are
          // describing a track that no longer exists.
          measure();
          // The cards that just landed have their own behaviour — the image
          // track inside each one — and it was bound before these existed.
          // Same contract the cart uses when it re-renders its lines.
          track.dispatchEvent(new CustomEvent('etree:cards-rendered', { bubbles: true }));
        } else if (track.children.length === 0) {
          section.setAttribute('hidden', '');
        }
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  /* Underlays the searched term inside result titles. Shopify hands back no
     match positions, so the wrap happens here, case-insensitively, over the
     rendered title.

     Under three characters it is skipped: a two-letter query underlines most
     of every title and the page reads as damaged rather than as answered.

     The query is shopper input, so it is escaped for the regex and inserted as
     text nodes — never through innerHTML. */
  (function () {
    var wrap = function () {
      var root = document.querySelector('[data-search-results]');
      if (!root) return;

      var query = (root.getAttribute('data-search-query') || '').trim();
      if (query.length < 3) return;

      var pattern = new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'ig');

      /* Results only. The catalogue grid under the empty state is not an answer
         to the query — underlaying "blazer" across five titles that do not
         contain it says the search half-worked. */
      var titles = root.querySelectorAll(
        '.search-page__grid:not(.search-page__grid--fallback) .product-card__title'
      );

      /* Text nodes, one at a time, replaced where they stand — not
         `title.textContent = ''` and a rebuilt title, which is what this did
         until 2026-09-14.

         The title is no longer only text. It holds the muted colour span the
         card gained that day, and it has always held the visually-hidden
         `Sold out` a sold-out card carries. Flattening the element to its text
         took both classes off: the colour lost its grey, and `Sold out` — meant
         for a screen reader — became a visible word in the middle of the name.
         Both needed a query that actually matched to show up, which is why
         neither was ever seen.

         Marking each text node in place leaves every element around it alone.
         The walk still reaches into the colour, so `navy` underlines the word it
         matched, and it refuses to enter anything visually hidden, which is text
         written for a screen reader rather than something on the page to find.

         Collected before anything is replaced: mutating the tree mid-walk moves
         the walker off the node it is standing on. */
      titles.forEach(function (title) {
        var walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT, {
          acceptNode: function (node) {
            return node.parentElement && node.parentElement.closest('.visually-hidden')
              ? NodeFilter.FILTER_REJECT
              : NodeFilter.FILTER_ACCEPT;
          },
        });

        var nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);

        nodes.forEach(function (node) {
          var text = node.nodeValue;
          var fragment = document.createDocumentFragment();
          var cursor = 0;
          var match;

          pattern.lastIndex = 0;
          while ((match = pattern.exec(text)) !== null) {
            if (match.index > cursor) {
              fragment.appendChild(document.createTextNode(text.slice(cursor, match.index)));
            }
            var hit = document.createElement('mark');
            hit.textContent = match[0];
            fragment.appendChild(hit);
            cursor = match.index + match[0].length;

            /* A zero-length match would spin forever. */
            if (match[0].length === 0) pattern.lastIndex += 1;
          }

          if (cursor === 0) return;
          if (cursor < text.length) {
            fragment.appendChild(document.createTextNode(text.slice(cursor)));
          }

          node.parentNode.replaceChild(fragment, node);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wrap);
    } else {
      wrap();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
